var render = function render(_c,_vm){return _c('div',{staticClass:"text"},[_c('span',{style:(_vm.props.row.color.color_text
        ? `color:${_vm.props.row.color.color_text}`
        : `mixBlendMode: 'difference'`)},[_vm._v("\n    "+_vm._s(_vm.props.row.color.color ? _vm.props.row.color.color : _vm.props.row.color))])])
}
var staticRenderFns = []

export { render, staticRenderFns }